import React from "react";
import ReactDOM from "react-dom/client";
import CartContext from "./cartContext.jsx";
import MiniCartContent from "./miniCartContent.jsx";
import scrapeSectionData from "../util/scrapeSectionData";
import FocusTrapWrapper from "./FocusTrap.jsx";

if (!customElements.get("section-minicart")) {
  class MiniCartSection extends HTMLElement {
    constructor() {
      super();
      const data = scrapeSectionData(this);
      const el = this.querySelector("[data-mini-cart-panel]");
      const content = el.querySelector("[data-mini-cart-component]");
      el.addEventListener(
        "openMiniCart",
        (e) => {
          const root = ReactDOM.createRoot(content);
          root.render(<MiniCart data={data} />);
        },
        false
      );
    }
  }
  customElements.define("section-minicart", MiniCartSection);
}

const MiniCart = ({ data }) => (
  <CartContext data={data}>
    <FocusTrapWrapper>
      <MiniCartContent />
    </FocusTrapWrapper>
  </CartContext>
);

export function generateRandomKey(length = 8) {
  const chars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export default MiniCart;
